export function getFormattedDate(date: string | undefined): string {
  if (!date) return '';
  const dateValue = new Date(date);
  const dateConvert = dateValue.toDateString().split(' ');
  return dateConvert[0] + ',' + ' ' + dateConvert[1] + ' ' + dateConvert[2];
}
